import React, { Component } from 'react';
import { flowRight } from 'lodash';
import { connect } from '../../../common/components/runtime-context';
import { isDebug } from '../../../common/store/basic-params/basic-params-selectors';
import styles from './status-indicator.scss';

const StatusIndicator = ({ isDebug }) => {
  if (!isDebug) {
    return null;
  }
  return <div className={styles.status}>Forum - Frameless</div>;
};

const mapRuntimeToProps = state => ({
  isDebug: isDebug(state),
});

export default flowRight(connect(mapRuntimeToProps))(StatusIndicator);
